var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ultimate-beneficiary" },
    [
      _c("fieldset", { staticClass: "info-group senior-top" }, [
        _c("legend", { staticClass: "senior-title" }, [
          _c(
            "span",
            {
              class:
                _vm.kycStatus === "saved" || _vm.kycStatus === "submitted"
                  ? "saved-title"
                  : "",
            },
            [_vm._v("\n        Ultimate Beneficiary (more than 25%)\n      ")]
          ),
        ]),
        _vm.kycStatus !== "submitted"
          ? _c("div", { staticClass: "senior-buttons" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-sm comfirm-ok",
                  on: { click: _vm.addSenior },
                },
                [_vm._v(_vm._s(_vm.$t("kyc.add")))]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-danger btn-sm comfirm-ok",
                  on: { click: _vm.deleteSelected },
                },
                [_vm._v(_vm._s(_vm.$t("delete")))]
              ),
            ])
          : _vm._e(),
      ]),
      _c("vuestic-widget", { attrs: { id: "dategridPayOrder" } }, [
        _c("div", [
          _c(
            "table",
            {
              staticClass: "table table-striped first-td-padding",
              attrs: { id: "seniorTable" },
            },
            [
              _c("thead", [
                _c(
                  "tr",
                  [
                    _c("th", [
                      _c("input", {
                        attrs: { type: "checkbox" },
                        on: { change: _vm.seniorCheckAll },
                      }),
                    ]),
                    _vm._l(_vm.tableHeaderList, function (item, index) {
                      return _c(
                        "th",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !(
                                _vm.kycStatus === "submitted" &&
                                item.label === "kyc.seniorManagement.action"
                              ),
                              expression:
                                "!(kycStatus==='submitted' && item.label === 'kyc.seniorManagement.action')",
                            },
                          ],
                          key: index,
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm._f("translate")(item.label)) +
                              "\n            "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]),
              _vm.isList
                ? _c(
                    "tbody",
                    _vm._l(_vm.ultimateBeneficiaryList, function (item, index) {
                      return _c("tr", { key: index }, [
                        _c("td", [
                          _c("input", {
                            attrs: { type: "checkbox" },
                            domProps: {
                              value: item.trade_no,
                              checked: item.checked,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.seniorCheckOne(arguments[0], index)
                              },
                            },
                          }),
                        ]),
                        _c("td", [_vm._v(_vm._s(item.name))]),
                        _c("td", [_vm._v(_vm._s(item.position))]),
                        _c("td", [
                          _vm._v(_vm._s(_vm.getIdTypeKey(item.id_type))),
                        ]),
                        _c("td", [_vm._v(_vm._s(item.id_number))]),
                        _c("td", [_vm._v(_vm._s(item.residence_address))]),
                        _c("td", [
                          _vm._v(_vm._s(item.is_pep === 1 ? "Yes" : "No")),
                        ]),
                        _c("td", [
                          _vm._v(_vm._s(item.is_sanction === 1 ? "Yes" : "No")),
                        ]),
                        _c("td", [
                          _vm._v(_vm._s(item.is_crime === 1 ? "Yes" : "No")),
                        ]),
                        _c("td", [
                          _c("div", { staticClass: "action-button" }, [
                            _c("img", {
                              attrs: { src: _vm.eyeIcon, alt: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.showSeniorFile(index, "id_proof")
                                },
                              },
                            }),
                          ]),
                        ]),
                        _c("td", [
                          _c("div", { staticClass: "action-button" }, [
                            _c("img", {
                              attrs: { src: _vm.eyeIcon, alt: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.showSeniorFile(
                                    index,
                                    "address_proof"
                                  )
                                },
                              },
                            }),
                          ]),
                        ]),
                        _c(
                          "td",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.kycStatus !== "submitted",
                                expression: "kycStatus!=='submitted'",
                              },
                            ],
                            staticClass: "senior-td-button",
                          },
                          [
                            _c("div", { staticClass: "action-button" }, [
                              _c("img", {
                                attrs: { src: _vm.copyIcon, alt: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.copyFunc(index)
                                  },
                                  mouseenter: function ($event) {
                                    return _vm.seniorCopyEnter(index)
                                  },
                                  mouseleave: function ($event) {
                                    return _vm.seniorCopyLeave(index)
                                  },
                                },
                              }),
                              _c("img", {
                                attrs: { src: _vm.editIcon, alt: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editSenior(index)
                                  },
                                },
                              }),
                              _c("img", {
                                attrs: { src: _vm.deleteIcon, alt: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteFunc(index)
                                  },
                                },
                              }),
                            ]),
                            _c(
                              "div",
                              {
                                ref: "seniorCopyFlag-" + index,
                                refInFor: true,
                                staticClass: "senior-copy-none",
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("kyc.copyToThePreviousList"))
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    }),
                    0
                  )
                : _c("tbody", [
                    _c("tr", [
                      _c("td", {
                        attrs: { colspan: "11" },
                        domProps: {
                          textContent: _vm._s(_vm.$t("t.noDataNoOrder")),
                        },
                      }),
                    ]),
                  ]),
            ]
          ),
        ]),
        _vm.isMobile === "pc"
          ? _c(
              "div",
              { staticClass: "block" },
              [
                _c("pagination", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.total > 0,
                      expression: "total>0",
                    },
                  ],
                  attrs: {
                    total: _vm.total,
                    "page-size": _vm.limit,
                    layout: "total, sizes, prev, pager, next, jumper",
                    background: "",
                    page: _vm.page,
                    limit: _vm.limit,
                  },
                  on: {
                    "update:page": function ($event) {
                      _vm.page = $event
                    },
                    "update:limit": function ($event) {
                      _vm.limit = $event
                    },
                    pagination: _vm.orderData,
                  },
                }),
              ],
              1
            )
          : _c(
              "div",
              { staticClass: "block" },
              [
                _c("pagination", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.total > 0,
                      expression: "total>0",
                    },
                  ],
                  attrs: {
                    total: _vm.total,
                    layout: "total, prev, pager, next",
                    background: "",
                    page: _vm.page,
                    limit: _vm.limit,
                  },
                  on: {
                    "update:page": function ($event) {
                      _vm.page = $event
                    },
                    "update:limit": function ($event) {
                      _vm.limit = $event
                    },
                    pagination: _vm.orderData,
                  },
                }),
              ],
              1
            ),
      ]),
      _c(
        "vuestic-modal",
        {
          ref: "seniorAdd",
          staticStyle: { height: "100%", width: "60vw" },
          attrs: {
            show: _vm.seniorAddshow,
            okText: _vm._f("translate")("modal.confirm2"),
            okClass: "btn btn-primary btn-micro",
            cancelClass: "btn btn-secondary btn-micro",
            cancelText: _vm._f("translate")("modal.cancel2"),
            alignModal: "",
          },
          on: {
            "update:show": function ($event) {
              _vm.seniorAddshow = $event
            },
          },
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.seniorAddTitle)),
          ]),
          _c("div", [
            _c("form", [
              _c("div", { staticClass: "va-row" }, [
                _c("div", { staticClass: "flex xs12 md12" }, [
                  _c("fieldset", [
                    _c("div", { staticClass: "info-group" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-group with-icon-right",
                          class: {
                            "has-error": _vm.errors.has("name"),
                            valid: _vm.isFormFieldValid("name"),
                          },
                        },
                        [
                          _c("div", { staticClass: "input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.addSeniorManage.name,
                                  expression: "addSeniorManage.name",
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'",
                                },
                              ],
                              attrs: {
                                id: "nameInput",
                                name: "name",
                                "data-vv-as": "Name",
                                autocomplete: "off",
                                required: "",
                              },
                              domProps: { value: _vm.addSeniorManage.name },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.addSeniorManage,
                                    "name",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-check valid-icon icon-right input-icon",
                            }),
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: { for: "name" },
                              },
                              [_vm._v("Name：")]
                            ),
                            _c("i", { staticClass: "bar" }),
                            _c(
                              "small",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("name"),
                                    expression: "errors.has('name')",
                                  },
                                ],
                                staticClass: "help text-danger",
                              },
                              [_vm._v(_vm._s(_vm.errors.first("name")))]
                            ),
                          ]),
                        ]
                      ),
                      _c("div", { staticClass: "info-group-space" }),
                      _c(
                        "div",
                        {
                          staticClass: "form-group with-icon-right",
                          class: {
                            "has-error": _vm.errors.has("position"),
                            valid: _vm.isFormFieldValid("position"),
                          },
                        },
                        [
                          _c("div", { staticClass: "input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.addSeniorManage.position,
                                  expression: "addSeniorManage.position",
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'",
                                },
                              ],
                              attrs: {
                                id: "positionInput",
                                name: "position",
                                "data-vv-as": "Position",
                                autocomplete: "off",
                                required: "",
                              },
                              domProps: { value: _vm.addSeniorManage.position },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.addSeniorManage,
                                    "position",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-check valid-icon icon-right input-icon",
                            }),
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: { for: "position" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("kyc.seniorManagement.position")
                                  )
                                ),
                              ]
                            ),
                            _c("i", { staticClass: "bar" }),
                            _c(
                              "small",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("position"),
                                    expression: "errors.has('position')",
                                  },
                                ],
                                staticClass: "help text-danger",
                              },
                              [_vm._v(_vm._s(_vm.errors.first("position")))]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "info-group" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-group with-icon-right",
                          class: {
                            "has-error": _vm.initIdTypeVaild,
                            valid: _vm.isIdTypeVaild("idType"),
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "input-group" },
                            [
                              _c("vuestic-kyc-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                ],
                                ref: "myInput",
                                attrs: {
                                  id: "idTypeInput",
                                  name: "idType",
                                  "data-vv-as": "ID Type",
                                  required: "",
                                  label:
                                    _vm.$t("kyc.seniorManagement.idType") +
                                    "：",
                                  "option-key": "value",
                                  options: _vm.idTypeOptions,
                                  autocomplete: "off",
                                },
                                on: {
                                  input: (val) => {
                                    _vm.idTypeStatus = !val ? true : false
                                  },
                                },
                                model: {
                                  value: _vm.addSeniorManage.idType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.addSeniorManage, "idType", $$v)
                                  },
                                  expression: "addSeniorManage.idType",
                                },
                              }),
                              _c("i", {
                                staticClass:
                                  "fa fa-exclamation-triangle error-icon icon-right input-icon",
                              }),
                              _c("i", {
                                staticClass: "fa icon-right input-icon",
                              }),
                              _c(
                                "small",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.initIdTypeVaild,
                                      expression: "initIdTypeVaild",
                                    },
                                  ],
                                  staticClass: "help text-danger",
                                },
                                [_vm._v(_vm._s(_vm.errors.first("idType")))]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "info-group-space" }),
                      _c(
                        "div",
                        {
                          staticClass: "form-group with-icon-right",
                          class: {
                            "has-error": _vm.errors.has("idNumber"),
                            valid: _vm.isFormFieldValid("idNumber"),
                          },
                        },
                        [
                          _c("div", { staticClass: "input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.addSeniorManage.idNumber,
                                  expression: "addSeniorManage.idNumber",
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'",
                                },
                              ],
                              attrs: {
                                id: "idNumberInput",
                                name: "idNumber",
                                "data-vv-as": "ID Number",
                                autocomplete: "off",
                                required: "",
                              },
                              domProps: { value: _vm.addSeniorManage.idNumber },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.addSeniorManage,
                                    "idNumber",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                            }),
                            _c("i", {
                              staticClass:
                                "fa fa-check valid-icon icon-right input-icon",
                            }),
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: { for: "idNumber" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("kyc.seniorManagement.idNumber")
                                  )
                                ),
                              ]
                            ),
                            _c("i", { staticClass: "bar" }),
                            _c(
                              "small",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("idNumber"),
                                    expression: "errors.has('idNumber')",
                                  },
                                ],
                                staticClass: "help text-danger",
                              },
                              [_vm._v(_vm._s(_vm.errors.first("idNumber")))]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "form-group with-icon-right",
                        class: {
                          "has-error": _vm.errors.has("residenceAddress"),
                          valid: _vm.isFormFieldValid("residenceAddress"),
                        },
                      },
                      [
                        _c("div", { staticClass: "input-group" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.addSeniorManage.residenceAddress,
                                expression: "addSeniorManage.residenceAddress",
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'",
                              },
                            ],
                            attrs: {
                              id: "residenceAddressInput",
                              name: "residenceAddress",
                              "data-vv-as": "Residence Address",
                              autocomplete: "off",
                              required: "",
                            },
                            domProps: {
                              value: _vm.addSeniorManage.residenceAddress,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.addSeniorManage,
                                  "residenceAddress",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _c("i", {
                            staticClass:
                              "fa fa-exclamation-triangle error-icon icon-right input-icon",
                          }),
                          _c("i", {
                            staticClass:
                              "fa fa-check valid-icon icon-right input-icon",
                          }),
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "residenceAddress" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "kyc.seniorManagement.residenceAddress"
                                  )
                                )
                              ),
                            ]
                          ),
                          _c("i", { staticClass: "bar" }),
                          _c(
                            "small",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("residenceAddress"),
                                  expression: "errors.has('residenceAddress')",
                                },
                              ],
                              staticClass: "help text-danger",
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.errors.first("residenceAddress"))
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                    _c("div", { staticClass: "info-group" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-group mb0",
                          class: {
                            "has-error": _vm.idProofStatus,
                            valid: _vm.idProofStatus,
                          },
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass:
                                "control-label upload-label app-logo-label-kyc",
                              attrs: { for: "idProof" },
                            },
                            [_vm._v("ID Proof：")]
                          ),
                          _c(
                            "div",
                            { staticClass: "app-logo-wrapper-kyc" },
                            [
                              _c("vuestic-file-upload-kyc", {
                                ref: "fieldInput",
                                attrs: { id: "idProof", type: "list" },
                                on: {
                                  input: function ($event) {
                                    return _vm.uploadFile(
                                      arguments[0],
                                      "idProof"
                                    )
                                  },
                                  removeFile: function ($event) {
                                    return _vm.removeFile(
                                      arguments[0],
                                      "idProof"
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.addSeniorManage.idProof,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.addSeniorManage,
                                      "idProof",
                                      $$v
                                    )
                                  },
                                  expression: "addSeniorManage.idProof",
                                },
                              }),
                              _c(
                                "small",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.idProofStatus,
                                      expression: "idProofStatus",
                                    },
                                  ],
                                  staticClass: "help text-danger",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("kyc.theIdProofFieldIsRequired")
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "info-group" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-group mb0",
                          class: {
                            "has-error": _vm.addressProofStatus,
                            valid: _vm.addressProofStatus,
                          },
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass:
                                "control-label upload-label app-logo-label-kyc",
                              attrs: { for: "idProof" },
                            },
                            [_vm._v("Address Proof：")]
                          ),
                          _c(
                            "div",
                            { staticClass: "app-logo-wrapper-kyc" },
                            [
                              _c("vuestic-file-upload-kyc", {
                                ref: "fieldInput",
                                attrs: { id: "addressProof", type: "list" },
                                on: {
                                  input: function ($event) {
                                    return _vm.uploadFile(
                                      arguments[0],
                                      "addressProof"
                                    )
                                  },
                                  removeFile: function ($event) {
                                    return _vm.removeFile(
                                      arguments[0],
                                      "addressProof"
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.addSeniorManage.addressProof,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.addSeniorManage,
                                      "addressProof",
                                      $$v
                                    )
                                  },
                                  expression: "addSeniorManage.addressProof",
                                },
                              }),
                              _c(
                                "small",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.addressProofStatus,
                                      expression: "addressProofStatus",
                                    },
                                  ],
                                  staticClass: "help text-danger",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "kyc.theAddressProofFieldIsRequired"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "info-group" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-group with-icon-right",
                          class: {
                            "has-error": _vm.initPepVaild,
                            valid: _vm.isPepVaild("pep"),
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "input-group" },
                            [
                              _c("vuestic-kyc-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                ],
                                ref: "myInput",
                                attrs: {
                                  id: "pepInput",
                                  name: "pep",
                                  "data-vv-as": "pep",
                                  required: "",
                                  label: _vm.$t("kyc.isAPep"),
                                  "option-key": "value",
                                  options: _vm.commonOptions,
                                  autocomplete: "off",
                                },
                                on: {
                                  input: (val) => {
                                    _vm.pepStatus = !val ? true : false
                                  },
                                },
                                model: {
                                  value: _vm.addSeniorManage.pep,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.addSeniorManage, "pep", $$v)
                                  },
                                  expression: "addSeniorManage.pep",
                                },
                              }),
                              _c("i", {
                                staticClass:
                                  "fa fa-exclamation-triangle error-icon icon-right input-icon",
                              }),
                              _c("i", {
                                staticClass: "fa icon-right input-icon",
                              }),
                              _c(
                                "small",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.initPepVaild,
                                      expression: "initPepVaild",
                                    },
                                  ],
                                  staticClass: "help text-danger",
                                },
                                [_vm._v(_vm._s(_vm.errors.first("pep")))]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "info-group-space" }),
                      _c(
                        "div",
                        {
                          staticClass: "form-group with-icon-right",
                          class: {
                            "has-error": _vm.initSanctionVaild,
                            valid: _vm.isSanctionVaild("sanction"),
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "input-group" },
                            [
                              _c("vuestic-kyc-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                ],
                                ref: "myInput",
                                attrs: {
                                  id: "sanctionInput",
                                  name: "sanction",
                                  "data-vv-as": "sanction",
                                  required: "",
                                  label: _vm.$t("kyc.inASanctionList"),
                                  "option-key": "value",
                                  options: _vm.commonOptions,
                                  autocomplete: "off",
                                },
                                on: {
                                  input: (val) => {
                                    _vm.sanctionStatus = !val ? true : false
                                  },
                                },
                                model: {
                                  value: _vm.addSeniorManage.sanction,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.addSeniorManage,
                                      "sanction",
                                      $$v
                                    )
                                  },
                                  expression: "addSeniorManage.sanction",
                                },
                              }),
                              _c("i", {
                                staticClass:
                                  "fa fa-exclamation-triangle error-icon icon-right input-icon",
                              }),
                              _c("i", {
                                staticClass: "fa icon-right input-icon",
                              }),
                              _c(
                                "small",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.initSanctionVaild,
                                      expression: "initSanctionVaild",
                                    },
                                  ],
                                  staticClass: "help text-danger",
                                },
                                [_vm._v(_vm._s(_vm.errors.first("sanction")))]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "info-group" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-group with-icon-right",
                          class: {
                            "has-error": _vm.initCrimeVaild,
                            valid: _vm.isCrimeVaild("crime"),
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "input-group" },
                            [
                              _c("vuestic-kyc-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                ],
                                ref: "myInput",
                                attrs: {
                                  id: "crimeInput",
                                  name: "crime",
                                  "data-vv-as": "crime",
                                  required: "",
                                  label: _vm.$t("kyc.anyCrime"),
                                  "option-key": "value",
                                  options: _vm.commonOptions,
                                  autocomplete: "off",
                                },
                                on: {
                                  input: (val) => {
                                    _vm.crimeStatus = !val ? true : false
                                  },
                                },
                                model: {
                                  value: _vm.addSeniorManage.crime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.addSeniorManage, "crime", $$v)
                                  },
                                  expression: "addSeniorManage.crime",
                                },
                              }),
                              _c("i", {
                                staticClass:
                                  "fa fa-exclamation-triangle error-icon icon-right input-icon",
                              }),
                              _c("i", {
                                staticClass: "fa icon-right input-icon",
                              }),
                              _c(
                                "small",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.initCrimeVaild,
                                      expression: "initCrimeVaild",
                                    },
                                  ],
                                  staticClass: "help text-danger",
                                },
                                [_vm._v(_vm._s(_vm.errors.first("crime")))]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "info-group-space" }),
                      _c("div", { staticClass: "form-group with-icon-right" }),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
      _c("large-image", {
        attrs: {
          isShowFileImage: _vm.isShowFileImage,
          filesList: _vm.fileArr,
          bigImage: _vm.bigImage,
          curFile: _vm.curFile,
          fileUrl: _vm.fileUrl,
        },
        on: {
          closeLargeImage: _vm.closeFileImage,
          showImage: _vm.showImageInit,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }